<template>
    <div :class="{section: true, prophecies: true, mobile: mobile()}">
        <img v-if="! mobile()" class="svg" src="@/assets/christmas/prophecies.svg">
        <img v-if="mobile()" class="svgMobile" src="@/assets/christmas/prophecies_mobile.svg">
        <img class="propheciesGround" :style="getStyle()" src="@/assets/christmas/propheciesGround.svg">
        <img class="buttonLine invisible" id="buttonLine" src="@/assets/christmas/buttonLine.gif">
        <p class="propheciesText">Im Alten Testament wurde bereits <b> 700 Jahre vor Christus</b> aufgeschrieben, dass Gott in Bethlehem als Mensch auf die Welt kommen wird.</p>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent";

    @Component()
    export default class Prophecies extends BasicComponent {

        onActive() {
            const buttonLine = document.getElementById("buttonLine");
            const src = buttonLine.src;
            buttonLine.src = src; // reload gif
            buttonLine.classList.remove("invisible");
        }

        mounted() {
            this.register();
        }

        getStyle() {
            const circleWidth = this.getCircleWidth();
            return {
                width: circleWidth + 'px',
                transform: "translate(-50%, " + (circleWidth - this.getWindowHeight()/10) + "px)"
            };
        }

        getCircleWidth() {
            return 2*this.getCircleRadius(this.getWindowWidth(), this.getWindowHeight()/10);
        }

    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .prophecies {
        background-color: $groundRed;
        position: relative;

        .title {
            font: Bold 48px/60px Source Sans Pro;

            width: 100%;
            text-align: center;

            position: relative;
            top: 50%;
            transform: translateY(-5vw);
        }

        .propheciesText {
            text-align: right;
            width: 300px;
            max-width: 35vw;
            position: absolute;
            top: 50%;
            right: 15%;
            font-weight: normal;
            font-size: 1.6em;
            color: white;
        }

        .svg {
            position: absolute;
            height: 85vh;
            max-width: 70vw;
            left: 10%;
            bottom: 10vh;
        }

        .propheciesGround {
            position: absolute;

            left: 50%;
            bottom: 0;
        }

        .svgMobile {
            position: absolute;
            bottom: 10vh;
            left: 0;
            height: 70vh;
            max-width: 80vw;

        }

        .buttonLine {
            width: 20vw;
            max-width: 250px;
            position: absolute;
            bottom: 30px;
            right: 50px;

            &.invisible {
                visibility: hidden;
            }
        }
    }

    .mobile {
        .propheciesText {
            font-size: 1.2em;
            max-width: 60vw;
            top: 60%;

            @media screen and (max-height: 600px) {
                font-size: 1em;
            }
        }

        .buttonLine {
            width: 50vw;
        }
    }

</style>
